import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { statusCssClass, statusLabel } from '../dispute.utils';

@Component({
    selector: 'app-dispute-status-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span class="dispute-status-pill" [ngClass]="cssClass">{{ label }}</span>
    `,
    styles: [
        `
            .dispute-status-pill {
                display: inline-flex;
                align-items: center;
                padding: 0.2rem 0.65rem;
                border-radius: 999px;
                font-size: 0.68rem;
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: uppercase;
                white-space: nowrap;
            }
            .status-submitted {
                background: var(--dispute-status-submitted-bg, color-mix(in srgb, var(--p-blue-500) 20%, transparent));
                color: var(--dispute-status-submitted-text, var(--p-blue-700));
                border: 1px solid color-mix(in srgb, var(--p-blue-500) 35%, transparent);
            }
            .status-review {
                background: var(--dispute-status-review-bg, color-mix(in srgb, var(--p-orange-500) 20%, transparent));
                color: var(--dispute-status-review-text, var(--p-orange-700));
                border: 1px solid color-mix(in srgb, var(--p-orange-500) 35%, transparent);
            }
            .status-approved {
                background: var(--dispute-status-approved-bg, color-mix(in srgb, var(--p-green-500) 20%, transparent));
                color: var(--dispute-status-approved-text, var(--p-green-700));
                border: 1px solid color-mix(in srgb, var(--p-green-500) 35%, transparent);
            }
            .status-rejected {
                background: var(--dispute-status-rejected-bg, color-mix(in srgb, var(--p-red-500) 20%, transparent));
                color: var(--dispute-status-rejected-text, var(--p-red-700));
                border: 1px solid color-mix(in srgb, var(--p-red-500) 35%, transparent);
            }
        `
    ]
})
export class DisputeStatusBadgeComponent {
    @Input({ required: true }) status!: string;

    get cssClass(): string {
        return statusCssClass(this.status);
    }

    get label(): string {
        return statusLabel(this.status);
    }
}
